import { GradientIcon, Heading } from '@sparemin/blockhead';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import DialogContent from 'components/DialogContent';
import { ThinWand } from 'components/icons';
import useContextualUpgrade from 'hooks/useContextualUpgrade';
import { onUnlockThisFeature } from 'redux/modules/mixpanel';
import { replaceModal } from 'redux/modules/modal';
import { block } from './utils';

const SaveCustomCaptionStyleUpsellModalContents = () => {
  const { onUpgrade } = useContextualUpgrade({ openModal: replaceModal });

  const dispatch = useDispatch();

  const handleUpgrade = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      dispatch(onUnlockThisFeature('SaveCustomCaptionStyle'));
      onUpgrade();
    },
    [dispatch, onUpgrade],
  );

  return (
    <DialogContent
      title="Saved caption styles are available on a Pro plan"
      icon={
        <GradientIcon>
          <ThinWand />
        </GradientIcon>
      }
      details={
        <Heading level={2}>You can upgrade to unlock this feature!</Heading>
      }
      actions={[
        {
          key: 'unlock-cta',
          theme: 'rainbow',
          children: 'upgrade your plan',
          onClick: handleUpgrade,
        },
      ]}
      className={block('contents')}
      titleClassName={block('title')}
      detailsClassName={block('details')}
    />
  );
};

export default SaveCustomCaptionStyleUpsellModalContents;
